let actionmodal = new Event('actionmodal');
let sectionFirst = document.querySelector('.main .section');
if (sectionFirst) {
    let computedStyle = window.getComputedStyle(sectionFirst);
    if (computedStyle) {
        switch (computedStyle.backgroundColor) {
            case 'rgb(111, 111, 113)':
            case 'rgb(0, 68, 255)':
            case 'rgb(29, 29, 31)':
                document.body.classList.add('body-section-black')
                break;
        }
    }
}

addEventListener('actionmodal', function (e) {
    switch (e.targetText) {
        case '#modal-video': {
            let video_content = e.element.querySelector('.video-content');
            if (video_content) {
                if (e.isOpen) {
                    let video = video_content.e('video', { controls: true }).e('source');
                    video.src = video_content.getAttribute('data-src');
                    video.type = video_content.getAttribute('data-mime');
                } else {
                    video_content.innerHTML = '';
                }
            }

        }
            break;
        default:
            break;
    }
})
let videoButtons = document.querySelectorAll("[data-target-video]");
if (videoButtons) {
    videoButtons.forEach(el => {
        el.addEventListener('click', function () {
            let targetvideo = el.getAttribute('data-target-video');
            let videoContent = document.querySelector(targetvideo);
            if (videoContent) {
                videoContent.innerHTML = '';
                videoContent.classList.add('open');
                let video = videoContent.e('video', { controls: true, autoplay: true }).e('source');
                video.src = videoContent.getAttribute('data-src');
                video.type = videoContent.getAttribute('data-mime');
                let tabcontent_scroll = videoContent.getBoundingClientRect();
                let y = tabcontent_scroll.top + scrollY - 12;
                $("html, body").animate({ scrollTop: y });
            }
        })
    })
}

// ====================== BEGIN TAB


let tabs = document.querySelectorAll('.tabs');
if (tabs) {
    tabs.forEach(tab => {
        window.tabCallback(tab)
    })
}

// ====================== END TAB


let databgs = document.querySelectorAll('[data-bg]');
if (databgs) {
    databgs.forEach(databg => {
        let color = window.findColor(databg.getAttribute('data-bg'));
        for (let index in color) {
            databg.style.setProperty(index, color[index]);
        }
    })
}

let searchButtons = document.querySelectorAll("[data-target-search]");
if (searchButtons) {
    searchButtons.forEach(element => {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            let targetsearch = element.getAttribute('data-target-search');
            let searchContent = document.querySelector(targetsearch);

            if (searchContent) {
                searchContent.classList.toggle('open');
                actionmodal.isOpen = searchContent.classList.contains('open');
                if (actionmodal.isOpen) {
                    $("#form-search .search-entry").val('');
                    $("#form-search .search-entry").focus();
                    $("#form-search #no-result").hide();
                    $("#form-search #search-result .count").hide();
                    $("#form-search #search-result .results-wrapper").html("");
                    $("#form-search #search-result").hide();
                }
                actionmodal.targetText = targetsearch;
                actionmodal.element = searchContent;
                document.body.classList.toggle('no-scroll');
                dispatchEvent(actionmodal);
            }
        })
    })
}


let buttonNavs = document.querySelectorAll('.buttonNav');
if (buttonNavs) {
    buttonNavs.forEach(buttonNav => {
        buttonNav.addEventListener('click', function () {
            document.body.classList.toggle('body-button-nav');
        })
    })

}



// WEBPACK FOOTER //
// ./scripts/before-load.js